// Class-Based Assessment Structure
// Each class has its own set of assessments organized by subject

export const classAssessmentStructure = {
  // YEAR 10 CLASSES
  "Year 10 Mathematics": {
    className: "Year 10 Mathematics",
    subject: "Mathematics",
    year: 10,
    assessments: [
      { title: "Algebra Quiz", max: 50, weight: 10, type: "Quiz", term: "Term 1", dueDate: "Week 2" },
      { title: "Geometry Test", max: 100, weight: 15, type: "Test", term: "Term 1", dueDate: "Week 5" },
      { title: "Statistics Project", max: 50, weight: 15, type: "Project", term: "Term 2", dueDate: "Week 3" }
    ]
  },
  
  "Year 10 English": {
    className: "Year 10 English",
    subject: "English",
    year: 10,
    assessments: [
      { title: "Reading Comprehension", max: 50, weight: 10, type: "Test", term: "Term 1", dueDate: "Week 3" },
      { title: "Creative Writing", max: 100, weight: 15, type: "Assignment", term: "Term 1", dueDate: "Week 6" },
      { title: "Oral Presentation", max: 50, weight: 15, type: "Presentation", term: "Term 2", dueDate: "Week 4" }
    ]
  },
  
  "Year 10 Social Science": {
    className: "Year 10 Social Science",
    subject: "Social Science",
    year: 10,
    assessments: [
      { title: "Pacific History Quiz", max: 50, weight: 10, type: "Quiz", term: "Term 1", dueDate: "Week 2" },
      { title: "Geography Project", max: 100, weight: 15, type: "Project", term: "Term 1", dueDate: "Week 7" },
      { title: "Cultural Studies Essay", max: 50, weight: 15, type: "Essay", term: "Term 2", dueDate: "Week 5" }
    ]
  },
  
  "Year 10 Basic Science": {
    className: "Year 10 Basic Science",
    subject: "Basic Science",
    year: 10,
    assessments: [
      { title: "Biology Test", max: 50, weight: 10, type: "Test", term: "Term 1", dueDate: "Week 3" },
      { title: "Chemistry Practical", max: 100, weight: 15, type: "Practical", term: "Term 1", dueDate: "Week 6" },
      { title: "Physics Quiz", max: 50, weight: 15, type: "Quiz", term: "Term 2", dueDate: "Week 2" }
    ]
  },

  // YEAR 11 CLASSES
  "Year 11 English": {
    className: "Year 11 English",
    subject: "English",
    year: 11,
    assessments: [
      { title: "Literature Analysis", max: 100, weight: 15, type: "Essay", term: "Term 1", dueDate: "Week 4" },
      { title: "Poetry Interpretation", max: 50, weight: 10, type: "Assignment", term: "Term 1", dueDate: "Week 7" },
      { title: "Drama Performance", max: 100, weight: 15, type: "Performance", term: "Term 2", dueDate: "Week 5" }
    ]
  },
  
  "Year 11 Mathematics": {
    className: "Year 11 Mathematics",
    subject: "Mathematics",
    year: 11,
    assessments: [
      { title: "Trigonometry Test", max: 100, weight: 15, type: "Test", term: "Term 1", dueDate: "Week 3" },
      { title: "Calculus Quiz", max: 50, weight: 10, type: "Quiz", term: "Term 1", dueDate: "Week 6" },
      { title: "Applied Math Project", max: 100, weight: 15, type: "Project", term: "Term 2", dueDate: "Week 4" }
    ]
  },

  "Year 11 Computer Studies": {
    className: "Year 11 Computer Studies",
    subject: "Computer Studies",
    year: 11,
    assessments: [
      { title: "Programming Basics Test", max: 100, weight: 15, type: "Test", term: "Term 1", dueDate: "Week 4" },
      { title: "Web Development Project", max: 100, weight: 15, type: "Project", term: "Term 1", dueDate: "Week 8" },
      { title: "Database Design Assignment", max: 50, weight: 10, type: "Assignment", term: "Term 2", dueDate: "Week 3" }
    ]
  },

  // YEAR 12 CLASSES
  "Year 12 Mathematics": {
    className: "Year 12 Mathematics",
    subject: "Mathematics",
    year: 12,
    assessments: [
      { title: "Advanced Calculus Test", max: 100, weight: 15, type: "Test", term: "Term 1", dueDate: "Week 3" },
      { title: "Statistics Assignment", max: 100, weight: 15, type: "Assignment", term: "Term 1", dueDate: "Week 7" },
      { title: "Applied Mathematics Project", max: 100, weight: 20, type: "Project", term: "Term 2", dueDate: "Week 5" }
    ]
  },
  
  "Year 12 English": {
    className: "Year 12 English",
    subject: "English",
    year: 12,
    assessments: [
      { title: "Critical Analysis Essay", max: 100, weight: 20, type: "Essay", term: "Term 1", dueDate: "Week 4" },
      { title: "Research Paper", max: 100, weight: 15, type: "Paper", term: "Term 1", dueDate: "Week 8" },
      { title: "Oral Examination", max: 50, weight: 15, type: "Oral", term: "Term 2", dueDate: "Week 3" }
    ]
  },

  "Year 12 Computer Studies": {
    className: "Year 12 Computer Studies",
    subject: "Computer Studies",
    year: 12,
    assessments: [
      { title: "Software Development Test", max: 100, weight: 15, type: "Test", term: "Term 1", dueDate: "Week 3" },
      { title: "Database Systems Project", max: 100, weight: 20, type: "Project", term: "Term 1", dueDate: "Week 8" },
      { title: "Networking Assignment", max: 100, weight: 15, type: "Assignment", term: "Term 2", dueDate: "Week 4" }
    ]
  },

  // YEAR 13 COMPUTER STUDIES - Full Curriculum with Units 1.1, 1.2, 1.3
  "Year 13 Computer Studies": {
    className: "Year 13 Computer Studies",
    subject: "Computer Studies",
    year: 13,
    assessments: [
      // Unit 1.1
      { 
        title: "Unit 1.1: Assessment Blueprint", 
        max: 15, 
        weight: 2,
        type: "Test",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.1",
        description: "Future ICT Trends formative assessment (MCQ & Short Answer)",
        blueprintId: "unit11_test",
        term: "Term 1",
        dueDate: "Week 2"
      },
      { 
        title: "Unit 1.1: ICT Exercises", 
        max: 35, 
        weight: 4,
        type: "Exercises",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.1",
        description: "ICT exercises with Vanuatu context",
        blueprintId: "unit11_exercises",
        term: "Term 1",
        dueDate: "Week 2"
      },
      // Unit 1.2
      { 
        title: "Unit 1.2: IS Management Test", 
        max: 60, 
        weight: 6,
        type: "Test",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
        description: "Workflows, IS applications, development and management",
        blueprintId: "unit12_test",
        term: "Term 1",
        dueDate: "Week 4"
      },
      { 
        title: "Unit 1.2: ICT Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
        description: "Practical exercises on IS concepts",
        blueprintId: "unit12_exercises",
        term: "Term 1",
        dueDate: "Week 4"
      },
      { 
        title: "Unit 1.2: ICT Assignment", 
        max: 60, 
        weight: 6,
        type: "Assignment",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.2",
        description: "Comprehensive IS management assignment",
        blueprintId: "unit12_assignment",
        term: "Term 1",
        dueDate: "Week 5"
      },
      // Unit 1.3
      { 
        title: "Unit 1.3: ICT & Networking Test", 
        max: 100, 
        weight: 10,
        type: "Test",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.3",
        description: "ICT Infrastructure and Networking Fundamentals",
        blueprintId: "unit13_test",
        term: "Term 1",
        dueDate: "Week 7"
      },
      { 
        title: "Unit 1.3: ICT Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.3",
        description: "Software choices and networking exercises",
        blueprintId: "unit13_exercises",
        term: "Term 1",
        dueDate: "Week 7"
      },
      { 
        title: "Unit 1.3: ICT Assignment", 
        max: 60, 
        weight: 6,
        type: "Assignment",
        linkedToScheme: "Strand 1: Personal Computer Systems - Unit 1.3",
        description: "Infrastructure planning and software selection",
        blueprintId: "unit13_assignment",
        term: "Term 1",
        dueDate: "Week 8"
      },
      // Unit 2.1 - Digital Media Fundamentals
      { 
        title: "Unit 2.1: Digital Media Test", 
        max: 60, 
        weight: 6,
        type: "Test",
        linkedToScheme: "Strand 2: Digital Media & Design - Unit 2.1",
        description: "Digital Media Fundamentals - Importance, Devices, Content Creation, Tools",
        blueprintId: "unit21_test",
        term: "Term 2",
        dueDate: "Week 2"
      },
      { 
        title: "Unit 2.1: ICT Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 2: Digital Media & Design - Unit 2.1",
        description: "Digital media exercises with Vanuatu cultural context",
        blueprintId: "unit21_exercises",
        term: "Term 2",
        dueDate: "Week 2"
      },
      { 
        title: "Unit 2.1: Cultural Festival Assignment", 
        max: 60, 
        weight: 6,
        type: "Assignment",
        linkedToScheme: "Strand 2: Digital Media & Design - Unit 2.1",
        description: "Vanuatu Cultural Festival digital media planning",
        blueprintId: "unit21_assignment",
        term: "Term 2",
        dueDate: "Week 3"
      },
      // Unit 2.2 - Web Design and Database Fundamentals
      { 
        title: "Unit 2.2: Web Design & Database Test", 
        max: 60, 
        weight: 6,
        type: "Test",
        linkedToScheme: "Strand 2: Digital Media & Design - Unit 2.2",
        description: "Web Design Requirements, CSS, HTML, Database-Driven Websites, Testing & Validation",
        blueprintId: "unit22_test",
        term: "Term 2",
        dueDate: "Week 5"
      },
      { 
        title: "Unit 2.2: Local Business Website Assignment", 
        max: 60, 
        weight: 6,
        type: "Assignment",
        linkedToScheme: "Strand 2: Digital Media & Design - Unit 2.2",
        description: "Create website for local Vanuatu business or tourism directory",
        blueprintId: "unit22_assignment",
        term: "Term 2",
        dueDate: "Week 6"
      },
      // Unit 3.1 - Data Representation
      { 
        title: "Unit 3.1: Data Representation Test", 
        max: 50, 
        weight: 5,
        type: "Test",
        linkedToScheme: "Strand 3: Programming - Unit 3.1",
        description: "Test on Unicode, number conversions, binary arithmetic, and logic gates",
        blueprintId: "unit31_test",
        term: "Term 2",
        dueDate: "Week 8"
      },
      { 
        title: "Unit 3.1: Assignment 1 - Digital Representation", 
        max: 30, 
        weight: 3,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.1",
        description: "Research and conversion exercises on character encoding and number systems",
        blueprintId: "unit31_a1",
        term: "Term 2",
        dueDate: "Week 3"
      },
      { 
        title: "Unit 3.1: Assignment 2 - Binary Arithmetic", 
        max: 35, 
        weight: 3,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.1",
        description: "Problem-solving exercises on binary addition, subtraction, multiplication, and division",
        blueprintId: "unit31_a2",
        term: "Term 2",
        dueDate: "Week 5"
      },
      { 
        title: "Unit 3.1: Assignment 3 - Logic Gates", 
        max: 25, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.1",
        description: "Truth table construction and logic circuit interpretation",
        blueprintId: "unit31_a3",
        term: "Term 2",
        dueDate: "Week 7"
      },
      { 
        title: "Unit 3.1: Assignment 4 - Circuit Design", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.1",
        description: "Application-based logic gate and circuit design",
        blueprintId: "unit31_a4",
        term: "Term 2",
        dueDate: "Week 8"
      },
      // Unit 3.2 - Introduction to Programming Concepts
      { 
        title: "Unit 3.2: Programming Concepts Test", 
        max: 60, 
        weight: 6,
        type: "Test",
        linkedToScheme: "Strand 3: Programming - Unit 3.2",
        description: "Test on programming lifecycle, design methodologies, pseudocode, flowcharts, and modular programming",
        blueprintId: "unit32_test",
        term: "Term 2",
        dueDate: "Week 12"
      },
      // Unit 3.3 - Microprocessors and Embedded Systems
      { 
        title: "Unit 3.3: Microprocessors and Embedded Systems Test", 
        max: 70, 
        weight: 7,
        type: "Test",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Test on microprocessor architecture, code execution, programming interfaces, and embedded systems applications",
        blueprintId: "unit33_test",
        term: "Term 3",
        dueDate: "Week 6"
      },
      { 
        title: "Unit 3.3: Assignment 1 - Inner Workings of Microprocessor", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Detailed analysis of microprocessor component interaction and instruction execution",
        blueprintId: "unit33_a1",
        term: "Term 3",
        dueDate: "Week 2"
      },
      { 
        title: "Unit 3.3: Assignment 2 - High-Level to Machine Language", 
        max: 15, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Research compilation stages and assembler functionality",
        blueprintId: "unit33_a2",
        term: "Term 3",
        dueDate: "Week 3"
      },
      { 
        title: "Unit 3.3: Assignment 3 - Programming Traffic Light System", 
        max: 15, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Design instruction sequences for microprocessor-controlled traffic lights",
        blueprintId: "unit33_a3",
        term: "Term 3",
        dueDate: "Week 4"
      },
      { 
        title: "Unit 3.3: Assignment 4 - Embedded Systems in Vanuatu", 
        max: 15, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Apply embedded systems concepts to Vanuatu context",
        blueprintId: "unit33_a4",
        term: "Term 3",
        dueDate: "Week 5"
      },
      { 
        title: "Unit 3.3: Assignment 5 - Software Reliability (Optional)", 
        max: 10, 
        weight: 1,
        type: "Assignment",
        linkedToScheme: "Strand 3: Programming - Unit 3.3",
        description: "Analyze importance of error-free software in critical embedded devices",
        blueprintId: "unit33_a5",
        term: "Term 3",
        dueDate: "Week 6"
      },
      // Unit 4.1 - Preventing Cyber Attacks and Threats
      { 
        title: "Unit 4.1: Cybercrime & Cybersecurity Test", 
        max: 100, 
        weight: 10,
        type: "Test",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Comprehensive test on cybercrime, cyber legislation, and cybersecurity measures",
        blueprintId: "unit41_test",
        term: "Term 3",
        dueDate: "Week 8"
      },
      { 
        title: "Unit 4.1: ICT Security Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Practical exercises covering definitions, threats, legal measures, and preventative plans",
        blueprintId: "unit41_exercises",
        term: "Term 3",
        dueDate: "Week 8"
      },
      { 
        title: "Unit 4.1: Assignment 1 - Research Project: Cybercrime in Vanuatu", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Research cybercrime in Vanuatu, analyze legislation, challenges, and propose solutions",
        blueprintId: "unit41_a1",
        term: "Term 3",
        dueDate: "Week 9"
      },
      { 
        title: "Unit 4.1: Assignment 2 - Case Study: Cyber-Attack in Pacific", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Analyze a cyber-attack scenario in the Pacific, assess impacts and response strategies",
        blueprintId: "unit41_a2",
        term: "Term 3",
        dueDate: "Week 9"
      },
      { 
        title: "Unit 4.1: Assignment 3 - Policy Proposal: Cybersecurity Awareness in Schools", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Develop a cybersecurity awareness campaign for Vanuatu secondary school",
        blueprintId: "unit41_a3",
        term: "Term 3",
        dueDate: "Week 10"
      },
      { 
        title: "Unit 4.1: Assignment 4 - Presentation: Phishing Threat in Vanuatu", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Present on phishing threats, tactics, impacts, and prevention in Vanuatu context",
        blueprintId: "unit41_a4",
        term: "Term 3",
        dueDate: "Week 10"
      },
      { 
        title: "Unit 4.1: Assignment 5 - Scenario: Responding to Malware Infection", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.1",
        description: "Problem-solving: Plan response to malware infection in small Vanuatu business",
        blueprintId: "unit41_a5",
        term: "Term 3",
        dueDate: "Week 10"
      },
      // Unit 4.2 - Ethical Measures in ICT
      { 
        title: "Unit 4.2: Ethical Measures in ICT Test", 
        max: 100, 
        weight: 10,
        type: "Test",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Comprehensive test on cybercrime definitions, landscape, legal measures, challenges and impacts",
        blueprintId: "unit42_test",
        term: "Term 3",
        dueDate: "Week 12"
      },
      { 
        title: "Unit 4.2: Ethical Measures Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Practical exercises on cybercrime, legislation, preventative measures and challenges",
        blueprintId: "unit42_exercises",
        term: "Term 3",
        dueDate: "Week 12"
      },
      { 
        title: "Unit 4.2: Assignment 1 - Research Project: Cybercrime in Vanuatu", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Research cybercrime landscape, legislation challenges and recommendations for Vanuatu",
        blueprintId: "unit42_a1",
        term: "Term 3",
        dueDate: "Week 13"
      },
      { 
        title: "Unit 4.2: Assignment 2 - Case Study: Pacific Cyber-Attack Analysis", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Analyze cyber-attack scenario, assess vulnerabilities, impacts and response strategies",
        blueprintId: "unit42_a2",
        term: "Term 3",
        dueDate: "Week 13"
      },
      { 
        title: "Unit 4.2: Assignment 3 - Policy: School Cybersecurity Awareness", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Develop cybersecurity awareness campaign proposal for Vanuatu school",
        blueprintId: "unit42_a3",
        term: "Term 3",
        dueDate: "Week 14"
      },
      { 
        title: "Unit 4.2: Assignment 4 - Presentation: Phishing Threats in Vanuatu", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Present on phishing threats, tactics, impacts and prevention measures in Vanuatu",
        blueprintId: "unit42_a4",
        term: "Term 3",
        dueDate: "Week 14"
      },
      { 
        title: "Unit 4.2: Assignment 5 - Scenario: Malware Response Plan", 
        max: 20, 
        weight: 2,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.2",
        description: "Develop incident response plan for malware infection in small Vanuatu business",
        blueprintId: "unit42_a5",
        term: "Term 3",
        dueDate: "Week 14"
      },
      // Unit 4.3 - Environmental Impact of ICT and Sustainable Technology
      { 
        title: "Unit 4.3: Environmental Impact of ICT Test", 
        max: 100, 
        weight: 10,
        type: "Test",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Comprehensive test on ICT waste, electricity usage, waste management and sustainable technology",
        blueprintId: "unit43_test",
        term: "Term 3",
        dueDate: "Week 16"
      },
      { 
        title: "Unit 4.3: Environmental Impact Exercises", 
        max: 50, 
        weight: 5,
        type: "Exercises",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Exercises on e-waste, environmental concerns, management measures and sustainable practices",
        blueprintId: "unit43_exercises",
        term: "Term 3",
        dueDate: "Week 16"
      },
      { 
        title: "Unit 4.3: Assignment 1 - Research: E-waste Management in Vanuatu", 
        max: 25, 
        weight: 2.5,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Research e-waste types, infrastructure, environmental challenges and recommendations for Vanuatu",
        blueprintId: "unit43_a1",
        term: "Term 3",
        dueDate: "Week 17"
      },
      { 
        title: "Unit 4.3: Assignment 2 - Case Study: ICT Electricity Impact on Vanuatu", 
        max: 25, 
        weight: 2.5,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Analyze ICT electricity consumption impact on Vanuatu's energy sector and propose strategies",
        blueprintId: "unit43_a2",
        term: "Term 3",
        dueDate: "Week 17"
      },
      { 
        title: "Unit 4.3: Assignment 3 - Campaign: Reducing E-waste in Vanuatu", 
        max: 25, 
        weight: 2.5,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Design community awareness campaign with target audience, messages and delivery methods",
        blueprintId: "unit43_a3",
        term: "Term 3",
        dueDate: "Week 18"
      },
      { 
        title: "Unit 4.3: Assignment 4 - Policy: Sustainable ICT Procurement", 
        max: 25, 
        weight: 2.5,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Develop policy recommendations for sustainable ICT procurement for Vanuatu Government",
        blueprintId: "unit43_a4",
        term: "Term 3",
        dueDate: "Week 18"
      },
      { 
        title: "Unit 4.3: Assignment 5 - Creative: Journey of Old Mobile Phone", 
        max: 25, 
        weight: 2.5,
        type: "Assignment",
        linkedToScheme: "Strand 4: Cybersecurity - Unit 4.3",
        description: "Create narrative/visual/video showing mobile phone journey and disposal outcomes in Vanuatu",
        blueprintId: "unit43_a5",
        term: "Term 3",
        dueDate: "Week 18"
      },
      // Additional Assessments
      { 
        title: "IA Draft 1", 
        max: 100, 
        weight: 10,
        type: "Internal Assessment",
        linkedToScheme: "Strand 1: Personal Computer Systems",
        description: "Internal Assessment Draft 1 - Digital Media & ICT Trends",
        term: "Term 1",
        dueDate: "Week 9"
      },
      { 
        title: "Moodle Activities", 
        max: 30, 
        weight: 3,
        type: "Online Activities",
        linkedToScheme: "Strand 1: Personal Computer Systems",
        description: "Online forum participation and activities",
        term: "Term 1",
        dueDate: "Ongoing"
      }
    ]
  }
};

// Get assessments for a specific class
export const getClassAssessments = (className) => {
  return classAssessmentStructure[className] || null;
};

// Get all classes with assessments
export const getAllClassesWithAssessments = () => {
  return Object.keys(classAssessmentStructure);
};

// Get assessments by year level
export const getAssessmentsByYear = (year) => {
  return Object.values(classAssessmentStructure).filter(
    classData => classData.year === year
  );
};

// Get assessments by subject
export const getAssessmentsBySubject = (subject) => {
  return Object.values(classAssessmentStructure).filter(
    classData => classData.subject === subject
  );
};

// Get filtered classes based on user permissions
export const getFilteredClasses = (user) => {
  const allClasses = getAllClassesWithAssessments();
  
  if (!user) return allClasses;
  if (user.role === 'admin' || user.role === 'principal' || user.classes === 'all') {
    return allClasses;
  }
  
  // For restricted users (like Computer Studies only)
  if (user.restrictedTo === 'computer-studies') {
    return allClasses.filter(className => 
      className.toLowerCase().includes('computer studies')
    );
  }
  
  // For users with specific class list
  if (Array.isArray(user.classes)) {
    return allClasses.filter(className => user.classes.includes(className));
  }
  
  return allClasses;
};
